<template>
    <div>
      <slot />

      <ToasterBase />
    </div>
  </template>
  
<script lang="ts" setup>  
  const nuxtApp = useNuxtApp()
  
  // nuxtApp.hook("page:finish", () => {
  //   if (process.client) window.scrollTo(0, 0)
  // })
</script>

<style>
#app, body, #__nuxt {
  background-color: transparent !important;
}
</style>